<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    scrollFunction() {
        if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
          var c = document.getElementById("normalBar");
          c.classList.add("inverted");
          var y = document.getElementById("2x");
          var x = document.getElementById("1x");
          var z = document.getElementById("3x");
          var w = document.getElementById("4x");
          var v = document.getElementById("5x");
          var g = document.getElementById("7x");
          y.classList.add("inverted")
          x.classList.add("inverted")
          z.classList.add("inverted")
          w.classList.add("inverted")
          v.classList.add("inverted")
          g.classList.add("inverted")
          var nodes = document.getElementById('4x').childNodes;
          for(var i=0; i<nodes.length; i++) {
              if (nodes[i].nodeName.toLowerCase() == 'div') {                  
                  nodes[i].classList.add("inverted")                
              }              
          }    
          
        }else{
          var x = document.getElementById("1x");
          var y = document.getElementById("2x");
          var z = document.getElementById("3x");
          var w = document.getElementById("4x");
          var v = document.getElementById("5x");
          var g = document.getElementById("7x");
          y.classList.remove("inverted")
          x.classList.remove("inverted")
          z.classList.remove("inverted")
          w.classList.remove("inverted")
          v.classList.remove("inverted")
          g.classList.remove("inverted")
          var c = document.getElementById("normalBar");
          c.classList.remove("inverted");    
          var nodes = document.getElementById('4x').childNodes;
          for(var i=0; i<nodes.length; i++) {
              if (nodes[i].nodeName.toLowerCase() == 'div') {                  
                  nodes[i].classList.remove("inverted")                
              }              
          }      
          //document.getElementById('title-submenu').classList.remove("inverted");

        }
      }
    },
    created () {
      window.addEventListener('scroll', this.scrollFunction);
      return
    }  
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Ubuntu');
*{
  font-family: 'Ubuntu', sans-serif;
}
html{
        scroll-behavior: smooth;
    }
body{
  margin:0;
}
#app {
  text-align: center;
}
  .el-card__body{
      padding:0px !important;
  }
  .el-input__inner{
      width:50% !important;
  }
.inverted{
  color:black !important;
  background: white;
}
.el-menu--horizontal > .el-submenu .el-submenu__title{
  color: white ;
}
.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow{
  color: white ;
}
.el-submenu:hover .el-submenu__icon-arrow{
  color: black !important ;
}
.el-submenu:hover{
  color: black !important;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li > a {
  color: black;
}

a{
  text-decoration: none;
}

li {
  display: inline-block;
  margin: 0 10px;
}
.el-message-box{
  width: 500px !important;
}
a {
  color: #42b983;
}

.chevere-text-j{
  text-align: justify;
  margin-right: 5%;
  margin-left: 5%;
}
.chevere-text-k{
  text-align: center;
  font-style: oblique;
  margin-right: 5%;
  margin-left: 5%;
}
.chevere-carousel-img{
  max-width: 100px;
}
.chevere-carousel-clientes{
  max-width: 300px;
}
.isotipo{
  max-width: 200px;
}
.chevere-title{
  font-family: 'Ubuntu', Times, serif;
  font-weight: bold; 
  font-size: 35px !important;
}
.chevere-title::after{
  content: '';
  position: absolute;
  left: 50%;
  /*bottom: 0px;*/
  width: 100px;
  height: 5px;
  margin-left: -50px;
  margin-top: 40px;
  background: #3d8e95;
}
@media only screen and (max-width: 600px) {
  .el-message-box{
    width: 300px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue